import { useMemo } from 'react'
import { useQueryParams } from './use-query-params'

export const ViewMode = {
    DOC_ONLY: 'docOnly',
    VIDEO_ONLY: 'videoOnly',
    VIDEO_AND_DOC: 'videoAndDoc',
}

export const useViewMode = () => {
    const queryViewMode = useQueryParams('mode')

    const isViewModeValid = Object.values(ViewMode).includes(queryViewMode as string)
    const viewMode = isViewModeValid ? queryViewMode : ViewMode.VIDEO_ONLY
    const isVideoOnly = viewMode === ViewMode.VIDEO_ONLY

    return useMemo(() => ({ viewMode, isVideoOnly }), [viewMode, isVideoOnly])
}
